import store from '@/store'

/**
 * 权限指令 v-permission
 * 用于控制页面按钮的显示和隐藏
 *
 * 使用示例：
 * v-permission="['all:video:save']"
 * v-permission="['all:video:update', 'all:video:delete']"  // 至少有一个权限就显示
 */
const permission = {
  bind(el, binding, vnode) {
    const { value } = binding

    if (value && value instanceof Array && value.length > 0) {
      // 获取按钮权限列表
      const btnMenus = store.getters['menu/getBtnMenus']
      const hasPermission = checkPermission(value, btnMenus)

      // 如果没有权限，隐藏该元素
      if (!hasPermission) {
        el.style.display = 'none'
      }
    } else {
      throw new Error(`v-permission 指令必须传递一个权限数组，如 v-permission="['btn:add']"`)
    }
  },
  update(el, binding, vnode) {
    const { value } = binding

    if (value && value instanceof Array && value.length > 0) {
      const btnMenus = store.getters['menu/getBtnMenus']
      const hasPermission = checkPermission(value, btnMenus)

      if (!hasPermission) {
        el.style.display = 'none'
      } else {
        el.style.display = ''
      }
    }
  }
}

/**
 * 检查权限
 * @param {Array} value 需要的权限数组 ['all:video:save']
 * @param {Array} btnMenus 用户拥有的按钮权限数组
 * @returns {Boolean} 是否有权限
 */
function checkPermission(value, btnMenus) {
  if (!btnMenus || btnMenus.length === 0) {
    return false
  }

  // 提取权限字符串 perms 数组
  const userPermissions = btnMenus.map(item => item.perms).filter(perm => perm)

  // 检查是否有任意一个权限
  return value.some(permission => userPermissions.includes(permission))
}

export default permission
